<template>
  <div class="card-info">
    <h2 class="mb-4">{{ $t('core.payment.titles.methods') }}</h2>
    <methods />
  </div>
</template>
<script>
  import Methods from '@payment/components/payment-form.vue';

  export default {
    components: { Methods }
  };
</script>